import request from '@/utils/request';

//招商项目产业链
export async function getProjectList(){
    return request({
        url: "/parcel-cms/project/chain/list",
        method: 'get',
    })
}
// 查询招商项目信息列表
export async function projectList(data) {
    return request({
      url: "/parcel-cms/project/page",
      method: "post",
      data: data,
    });
  }
// 查询招商项目信息详情
export async function getProjectDetails(id) {
    return request({
      url: "/parcel-cms/project/detail/" +id ,
      method: "get",
    });
  }
  // 根据项目id查询招商项目的可供地块
  export async function inquireKGDK(id){
    return request({
      url: "/parcel-cms/project/parcel-list/" +id ,
      method: "get",
    });
  }
    // 根据项目id查询招商项目的可供地块
    export async function inquireKGDKnearby(id){
      return request({
        url: "/parcel-cms/project/parcel-near-list/" +id ,
        method: "get",
      });
    }


  //根据数据id获取招商项目图形信息
  export async function getCoverageInfo(id){
    return request({
      url: "/parcel-cms/project/shp/" +id ,
      method: "get",
    });
  }

  // 根据id获取招商项目的图形信息
export async function getProjectShp(data){
  return request({
    url: "/zxd-ywgl/project/shp/"+data,
    method: "get",
  });
}
  // 招商项目获取产业类别标签信息列表
export async function projectGetTag(data){
  return request({
       url:"/parcel-cms/label/list",
       method:"get",
       params:data
  })
}
// 根据项目id查询所关联的地块列表-带矢量
export async function projectIDLIST(id){
  return request({
    url: "/parcel-cms/project/project/parcel-shp/" +id ,
    method: "get",
  });
}
// 根据id获取文件图片信息
export async function projectPictureId(id){
  return request({
    url: "/parcel-cms/project/picture/" +id ,
    method: "get",
  });
}
// 招商项目查询全部
export async function getProjectAll(data){
  return request({
    url:"/parcel-cms/project/list",
    method:"post",
    data:data
  })
}